import React from "react";
// Image imports (update paths as necessary)
import individualCleaningImg from "../images/individualcleaning.jpg";
import businessCleaningImg from "../images/welcome.jpg";
import whyChooseImg from "../images/cleaning.jpg";

const Cleaning = () => {
  return (
    <><div className="cleaning-container">
      <h1>Cleaning Agency</h1>

      <p className="intro">
        VOETA provides professional cleaning services for individuals, businesses, and government facilities.
        Our trained teams ensure quality, reliability, and confidentiality across every cleaning engagement.
      </p>

      <section className="cleaning-section">
        <img src={individualCleaningImg} alt="Residential Cleaning" className="section-image" />
        <div>
          <h2>For Individuals</h2>
          <p>
            We offer flexible and discreet residential cleaning options that fit your lifestyle, schedule, and hygiene expectations.
          </p>
          <ul>
            <li>One-time deep cleaning</li>
            <li>Weekly, biweekly, or monthly home cleaning</li>
            <li>Move-in/move-out services</li>
            <li>Post-renovation cleaning</li>
          </ul>
        </div>
      </section>

      <section className="cleaning-section reverse">
        <img src={businessCleaningImg} alt="Commercial Cleaning" className="section-image" />
        <div>
          <h2>For Businesses</h2>
          <p>
            Maintain a safe and presentable work environment with our reliable commercial cleaning services.
            We tailor solutions for offices, retail, warehouses, and more.
          </p>
          <ul>
            <li>Office and facility cleaning</li>
            <li>After-hours cleaning</li>
            <li>Disinfection and sanitation services</li>
            <li>Floor, carpet, and window cleaning</li>
          </ul>
        </div>
      </section>

      <section className="cleaning-section">
        <img src={whyChooseImg} alt="Why Choose Us" className="section-image" />
        <div>
          <h2>Why Choose VOETA?</h2>
          <ul>
            <li>Fully insured and background-checked teams</li>
            <li>Custom scheduling options</li>
            <li>Environmentally-friendly cleaning products from USA available</li>
            <li>Clear, up-front pricing with no hidden fees</li>
          </ul>
        </div>
      </section>
    </div><style>
        {`
.cleaning-container {
  padding: 20px;
  max-width: 1200px;
  margin: auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
}

.cleaning-container h1 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.cleaning-container .intro {
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 2rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.cleaning-section {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 2rem;
  margin-bottom: 3rem;
  flex-wrap: nowrap;
}

.cleaning-section > div {
  flex: 1;
  min-width: 280px;
}

.cleaning-section.reverse {
  flex-direction: row-reverse;
}

.section-image {
  width: 100%;
  max-width: 500px;
  border-radius: 8px;
  object-fit: cover;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  flex-shrink: 0;
}

.cleaning-section h2 {
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
}

.cleaning-section p {
  font-size: 1rem;
  margin-bottom: 1rem;
}

.cleaning-section ul {
  list-style-type: disc;
  padding-left: 1.5rem;
}

@media (max-width: 968px) {
.cleaning-container {
  padding: 20px;
  margin: auto;
  max-width: none;
  width: 100%;

}
  .cleaning-section {
    flex-direction: column;
    text-align: left;
    font-size: 15px;
  }
.cleaning-container h1 {
  font-size: 20px;
}
.cleaning-container h2 {
  font-size: 20px;
}
.cleaning-container .intro {
  font-size: 15px;
}
  .cleaning-section p {
  font-size: 15px;
}
  .cleaning-section.reverse {
    flex-direction: column;
  }

  .section-image {
    width: 100%;
  }

  .cleaning-section > div {
    text-align: left;
  }
}

`}
      </style></>
  );
};

export default Cleaning;
